import React, { useState, useEffect, useRef } from 'react';
import CRFComponent from '../../../component/crf';
import styles from './index.module.scss';
import { ApiCore } from '../../../api/index';
import { Toast } from 'antd-mobile-v5';
import { useHistory } from 'react-router-dom';
import utils from '../../../utils/utils';
const api = new ApiCore();

const CreateRecord = (props: any) => {

    const [formData, setFormData] = useState<any>(null)
    const [taskCode, setTaskCode] = useState('')
    const [caseCode, setCaseCode] = useState('')

    const CrfRef: any = useRef()
    const history: any = useHistory();


    useEffect(() => {
        window.document.title = '建档信息'
        history.replace("/login")
        return
        if (window.location.href.split('?').length > 2) {
            let url = window.location.href.split('?')[0] + '?' + window.location.href.split('?')[1]
            window.location.replace(url)
        } else {
            patientCreate()
        }
    }, [props])


    /**
     * 预创建患者信息
     */
    const patientCreate = () => {
        let url = window.location.href.split('?')[0] + '?' + window.location.href.split('?')[1]
        const urlParams = utils.getUrlParams(url) || {};
        if (!urlParams.caseCode) {
            return
        }

        const params = new FormData();
        params.append('caseCode', urlParams.caseCode);

        api.getCaseFileInfo(params, {
            'Content-Type': 'application/x-www-form-urlencoded'
        }).then((res: any) => {
            if (res.code === 0) {

                let mToken: any = sessionStorage.getItem('token')
                let formData = {
                    caseCode: urlParams.caseCode,
                    userCode: JSON.parse(mToken).userCode,
                    crfVersion: res.data.tasks[0].formVersion,
                    crfCode: res.data.tasks[0].formCode,
                    recordCode: res.data.tasks[0].code,
                    tenantCode: localStorage.getItem('tenantCode'),
                    channel: "EDC"
                }
                console.log(formData);
                setFormData(formData)
                setTaskCode(res.data.tasks[0].code)
                setCaseCode(res.data.caseCode)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }


    /**
     * 保存表单内容
     */
    const handleSave = () => {
        CrfRef.current.handleSave()
    }


    /**
    * 表单内容保存成功的回调
    * @param formData 
    */
    const onSaveSuccess = (formData: any) => {
        let formDatas: any = {};
        formData.values.forEach((v: any) => {
            formDatas[v.dataCode] = v.value
        })
        let params = {
            taskCode: taskCode,
            formDatas
        }
        api.finishTask(params).then((res: any) => {
            if (res.code === 0) {
                Toast.show({
                    icon: 'success',
                    content: '保存成功',
                    duration: 1000
                })
                history.replace(`/pfizer/patient/home`)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })

    }


    // crf 加载成功关闭遮罩层 false->关闭
    const initCrfSuccess = (value: any) => {
        // setShowMask(value)
    }

    // crf 表单数据修改时
    const handleValuesChange = (value: any) => {
        // setCrfFormChange(value)
    }

    return (
        <div className={styles.nextCotent}>
            <div className={styles.contentTitle}>
                <div>请补充下列建档信息</div>
            </div>
            <div className={styles.block}></div>
            {formData && <div className={styles.crf_content}>
                <CRFComponent
                    ref={CrfRef}
                    params={formData}
                    onSaveSuccess={(v: any) => onSaveSuccess(v)}
                    readonly={false}
                    initCrfSuccess={(v: any) => initCrfSuccess(v)}
                    handleValuesChange={(v: any) => handleValuesChange(v)}
                />
            </div>}
            <div className={styles.actonBtns}>
                <div className={styles.backBtn} onClick={() => history.replace(`/pfizer/patient/home`)}>返回</div>
                <div className={styles.nextBtn} onClick={handleSave}>完成</div>
            </div>
        </div>
    )
}

export default CreateRecord;